// src/api/authApi.ts
import apiClient from '../api/apiClient';
import {ResponseDto} from "./ResponseDto";
import {SeniorFormData} from "../interface/SeniorFormData";

export const seniorAdd = (data: any) => {
    return apiClient.post('/api/front/senior/addSenior', data);
};

export const getSeniorList = () =>
    apiClient.get<ResponseDto<SeniorFormData[]>>("/api/front/senior/getSeniorList");

export const getSeniorDetail = (seniorCode: string) =>
    apiClient.get<ResponseDto<SeniorFormData>>(`/api/front/senior/getSeniorDetail/${seniorCode}`);

export const deleteSenior = (seniorCode: string) =>
    apiClient.delete<ResponseDto<SeniorFormData>>(`/api/front/senior/delete/${seniorCode}`);

export const updateSenior = (seniorCode: string, data: Partial<SeniorFormData>) =>
    apiClient.put<ResponseDto<null>>(`/api/front/senior/update/${seniorCode}`, data);

export const checkAndSaveSenior = (data: Partial<SeniorFormData>) =>
    apiClient.post<ResponseDto<string>>('/api/front/senior/checkAndSave', data);